<template>
  <label class="inline-flex flex-col gap-0.5">
    <!-- A text filter for a filter bar: label above, FilterDropdown's box. -->
    <span :class="FILTER_LABEL">{{ label }}</span>
    <input
      :value="modelValue"
      type="text"
      :class="[FILTER_BOX, 'w-full']"
      :placeholder="placeholder"
      @input="$emit('update:modelValue', $event.target.value)"
    >
  </label>
</template>

<script>
import { FILTER_BOX, FILTER_LABEL } from './filterBox';

export default {
  name: 'FilterTextInput',
  props: {
    label: { type: String, required: true },
    modelValue: { type: String, default: '' },
    placeholder: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  data() {
    return { FILTER_BOX, FILTER_LABEL };
  },
};
</script>
